
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';

import Tooltip from 'antd/lib/tooltip';
import deleteIcon from '../../../../../../assets/icons/actionsbutton/delete.png';
import deleteIconBlue from '../../../../../../assets/icons/blueStyle/delete-blue.png';
import plus from '../../../../../../assets/icons/button/plus.png';
import SelectInput from '../../../../../../components/ui/Inputs/SelectInput/SelectInput';
import CheckboxInput from '../../../../../../components/ui/Inputs/CheckboxInput/CheckboxInput';

// --------------------------------------------
// ↓ Funciton Body ↓
// --------------------------------------------

const ResponseGroupModule = ({
    control,
    disabled,
    watch,
    setValue,
    partnerValues,
    setPartnerValues,
    setNewPartnerView,
    handleGetContractors,
    contractors,
    ressources,
    blueStyle = false,
    accordCadreValue
}) => {

    const [responseGroupLabel, setResponseGroupLabel] = useState('Terre d\'avance');

    const taRoleValue = watch('response_groupement');
    const subsidiaryValue = watch('subsidiary');

    const isParentMandataire = accordCadreValue?.contractors?.length && accordCadreValue?.contractors?.every((contractor) => contractor.is_cocontractor)

    const isParentCocontractant = accordCadreValue?.contractors?.length && accordCadreValue?.contractors?.some((contractor) => !contractor.is_cocontractor)

    const mandataire = accordCadreValue?.contractors?.find((contractor) => !contractor.is_cocontractor)

    let taRoles = [
        { id: 1, name: 'Seul' },
        { id: 2, name: 'Mandataire' },
        { id: 3, name: 'Cotraitant' }
    ]

    if (accordCadreValue && !accordCadreValue?.contractors?.length) {
        taRoles = [{ id: 1, name: 'Seul' }];
    }

    if (isParentMandataire) {
        taRoles = [
            { id: 1, name: 'Seul' },
            { id: 2, name: 'Mandataire' }
        ];
    }

    if (isParentCocontractant) {
        taRoles = [
            { id: 1, name: 'Seul' },
            { id: 3, name: 'Cotraitant' }
        ];
    }

    const [partnerRoles, setPartnerRoles ] = useState(
        [
            { id: 1, name: 'Cotraitant' },
            { id: 2, name: 'Mandataire' }
        ]
    );

    useEffect(() => {

        // ↓ contractor dropdown values
        (async () => {
            await handleGetContractors('', 1);
        })();

    }, []);

    useEffect(() => {
        if (accordCadreValue && !accordCadreValue?.contractors?.length) {
            setPartnerValues([]);
            setValue('response_groupement', {id: 1, name: 'Seul'});
        }

    }, [])

    // --------------------------------------------
    // ↓ Rerender form to update response grouping label on change of subsidiary ↓
    // --------------------------------------------
    useEffect(() => {
        if (!subsidiaryValue) return;
        setResponseGroupLabel(subsidiaryValue?.name ===  "Terre d'Avance Formation" ? "Terre d'Avance Formation" : "Terre d'Avance");
    }, [subsidiaryValue])

    useEffect(() => {
        if (!taRoleValue) return;

        if (taRoleValue.name === "Seul") {
            setPartnerValues([{ id: Math.random(), ressource: null, role: '' }]);
        }

        if (taRoleValue.name === "Mandataire") {
            const setPartnerValuesToMandataire = partnerValues.map((partner) => {
                return {
                    ...partner,
                    role: {id: 1, name: 'Cotraitant'}
                }
            });
            setPartnerRoles((setPartnerRoles) => setPartnerRoles.filter((role) => role.name === "Cotraitant"));
            setPartnerValues((setPartnerValuesToMandataire))
        }

        if (mandataire && taRoleValue.name === "Cotraitant") {

            setPartnerRoles([
                { id: 1, name: 'Cotraitant' }
                // { id: 2, name: 'Mandataire' }
            ]);
            setPartnerValues([{id: Math.random(), ressource: mandataire.contractor, role: { id: 2, name: 'Mandataire' }}])

        }
    }, [taRoleValue])

    useEffect(() => {

        if (partnerValues.length && taRoleValue?.name === "Cotraitant" && partnerValues.some((partner) => partner?.role?.name === "Mandataire")) {
            setPartnerRoles([
                { id: 1, name: 'Cotraitant' }
            ]);
        }

        if (partnerValues.length && taRoleValue?.name === "Cotraitant" && partnerValues.every((partner) => partner?.role?.name === "Cotraitant")) {
            setPartnerRoles([
                { id: 1, name: 'Cotraitant' },
                { id: 2, name: 'Mandataire' }
            ]);
        }
    }, [])

    const handleAddPartner = () => {
        if (partnerValues.length < 10) {
            setPartnerValues((prevState) => [...prevState, {id: Math.random(), role: '', ressource: null}]);
        }
    }

    const handleRemovePartner = (id) => {
        setPartnerValues((prevState) => prevState.filter((element) => element.id !== id));
    }

    const handlePartnerValueChange = (e, id, type) => {
        setPartnerValues((prevState) => prevState.map((el) => el.id === id ? { ...el, [type]: e}  : el));
    }

    const filterOutAlreadySelected = (options, selected) => {
        const filteredArray = options.filter(obj1 =>
            !selected.some(obj2 =>
                accordCadreValue ? obj1?.contractor?.name === obj2?.ressource?.name : obj1?.name === obj2?.ressource?.name
            )
        );

        return filteredArray;
    };

    return (
        <>

            <div className="flex justify-start pl-2 text-gradient w-full pb-2 pt-4 mb-6 border-b border-gray-200">
                        Groupement de réponse
            </div>
            <div className="pb-3 w-full border-b border-gray-200">
                <div className='flex justify-start items-center w-full'>
                    <Controller
                        name="response_groupement"
                        control={control}
                        rules={{required: {
                            value: true,
                            message: 'Veuillez saisir le rôle'
                        }}}
                        render={({
                            field: {onChange, ref, value},
                            fieldState: {error}
                        }) => (
                            <SelectInput
                                label={responseGroupLabel}
                                placeholder='Rôle'
                                inputRef={ref}
                                width='w-[500px]'
                                error={error}
                                value={value}
                                options={taRoles}
                                onChange={onChange}
                                labelKeys={['name']}
                                disabled={disabled}
                                labelWidth="w-[245px]"
                            />
                        )}
                    />
                    {taRoleValue && taRoleValue.name === "Cotraitant" ?
                        <div className='ml-4'>
                            <Controller
                                name="is_direct"
                                control={control}
                                render={({
                                    field: {onChange, ref, value},
                                    fieldState: {error}
                                }) => (
                                    <CheckboxInput
                                        label='Paiement direct'
                                        blueStyle={blueStyle}
                                        inputRef={ref}
                                        error={error}
                                        value={value}
                                        onChange={onChange}
                                        disabled={disabled}
                                    />
                                )}
                            />
                        </div> : null }
                </div>
                {taRoleValue?.name !== "Seul" ?  <div className='mt-2 w-full'>
                    {
                        partnerValues.map((partner, index) => {
                            return (
                                <div
                                    className='flex w-full'
                                    key={partner.id}
                                >
                                    <div className='w-full flex mb-1.5'>
                                        <div className='flex justify-start'>
                                            {
                                                index === 0 ?
                                                    <div className='flex flex-col justify-center mr-[14.5px]'>
                                                        <Tooltip title='Créer un partenaire'>
                                                            <button
                                                                onClick={() => setNewPartnerView(true)}
                                                                disabled={!(partnerValues.length < 10)}
                                                                className={`
                                                                    p-1 rounded-full ${partnerValues.length < 10 ? 'hover:opacity-90' : ''}
                                                                    ${blueStyle ? 'background-gradient-blue' : 'background-gradient'}
                                                                    ${!(partnerValues.length < 10) ? 'opacity-[40%]' : 'opacity-100'}
                                                                `}
                                                            >
                                                                <img src={plus} alt='plus' className='w-6'/>
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                    : <div className="w-6 ml-[17px]"></div>
                                            }
                                            <SelectInput
                                                placeholder='Partenaire'
                                                value={partner.ressource}
                                                options={filterOutAlreadySelected(accordCadreValue ? accordCadreValue.contractors : contractors?.options, partnerValues)}
                                                onChange={(e) => handlePartnerValueChange(e, partner.id, 'ressource')}
                                                labelKeys={accordCadreValue && !mandataire ? ['contractor.name'] : ['name']}
                                                disabled={mandataire && partner?.ressource?.id === mandataire?.contractor?.id || disabled}
                                                fetchFunction={handleGetContractors}
                                                hasNextPage={contractors?.hasNextPage}
                                                width = 'w-[200px]'
                                                isSearchable={true}
                                                loading={!ressources}
                                                labelWidth='w-40'
                                            />
                                            <div className='ml-3 w-full'>
                                                <SelectInput
                                                    placeholder='Rôle'
                                                    // inputRef={ref}
                                                    width='w-[500px]'
                                                    // error={error}
                                                    value={partner.role}
                                                    options={partnerRoles}
                                                    onChange={(e) => handlePartnerValueChange(e, partner.id, 'role')}
                                                    labelKeys={partnerRoles.length ? ["name"] : null}
                                                    required={true}
                                                    disabled={mandataire && partner?.ressource?.id === mandataire?.contractor?.id || disabled}
                                                />
                                            </div>

                                            <div className='flex flex-col justify-center'>
                                                {
                                                    index === 0 ?
                                                        <Tooltip title='Assigner un partenaire existant'>
                                                            <div
                                                                onClick={handleAddPartner}
                                                                className={`whitespace-nowrap cursor-pointer text-sm text-gradient ${partnerValues.length < 10 ? "text-[#646464]" : "text-[#b2bec3]"} ml-1`}
                                                            >
                                                                <p className='hover:underline'>Ajouter un partenaire</p>
                                                            </div>
                                                        </Tooltip>
                                                        : <button
                                                            onClick={() => handleRemovePartner(partner.id)}
                                                            disabled={disabled}
                                                            className="bg-transparent"
                                                        >
                                                            <Tooltip title='Supprimer'>
                                                                <div>
                                                                    <img src={blueStyle ? deleteIconBlue : deleteIcon} alt="logo" className="w-6"/>
                                                                </div>
                                                            </Tooltip>
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div> : null}
            </div>
        </>
    );
}

export default ResponseGroupModule;
